import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron", "bodyFrame"]
  static values = {
    expanded: Boolean,
    bodyUrl: String,
    bodyLoaded: { type: Boolean, default: false }
  }

  connect() {
    this.updateView()
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue

    if (this.expandedValue && !this.bodyLoadedValue && this.bodyUrlValue) {
      this.loadBody()
    }

    this.updateView()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  loadBody() {
    if (this.hasBodyFrameTarget && this.bodyUrlValue) {
      this.bodyFrameTarget.src = this.bodyUrlValue
      this.bodyLoadedValue = true
    }
  }

  updateView() {
    if (this.hasContentTarget) {
      if (this.expandedValue) {
        this.contentTarget.classList.remove("hidden")
      } else {
        this.contentTarget.classList.add("hidden")
      }
    }

    if (this.hasChevronTarget) {
      if (this.expandedValue) {
        this.chevronTarget.classList.add("rotate-180")
      } else {
        this.chevronTarget.classList.remove("rotate-180")
      }
    }
  }

  expandedValueChanged() {
    this.updateView()
  }
}
